export default "__VITE_ASSET__C$cmuQHw__"